import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router, NavigationEnd } from '@angular/router'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { logging } from 'protractor';

@Injectable()
export class ApplicationService {
  public loginUserDetails = {
    "userid": "",
    "token": "",
    "name": "",
    "isAdmin": false,
    "profileImage":"",
    "partnertype":"",
    "partnertypeId":""
  }

  // constructor() {
  //   let loginUser = JSON.parse(localStorage.getItem('currentUser'));    
  //   if (loginUser) {
  //     if(loginUser.userDetail.isAdmin)
  //     {
  //       this.loginUserDetails.userid = loginUser.userDetail.id;
  //       this.loginUserDetails.token = loginUser.token;
  //       this.loginUserDetails.name = loginUser.userDetail.name;
  //       this.loginUserDetails.isAdmin=true;       
  //       this.loginUserDetails.profileImage=loginUser.userDetail.profileImage;
  //       this.loginUserDetails.partnertypeId= "-1";
  //       this.loginUserDetails.partnertype= "Administrator";
  //     }
  //     else{
  //       this.loginUserDetails.userid = loginUser.userDetail.partnerId;
  //       this.loginUserDetails.token = loginUser.token;
  //       this.loginUserDetails.name = loginUser.userDetail.partnerName;
  //       this.loginUserDetails.isAdmin=false;
  //       this.loginUserDetails.profileImage=loginUser.userDetail.partnerProfileImage;
  //       this.loginUserDetails.partnertypeId= loginUser.userDetail.partnertypeid;
  //       this.loginUserDetails.partnertype= loginUser.userDetail.partnerType;
  //     }
     
  //   }

  // }

  constructor() {    
    let loginUser = JSON.parse(localStorage.getItem('currentUser'));  
    if (loginUser) {
      this.loginUserDetails.userid = loginUser.userDetail.id;
      this.loginUserDetails.token = loginUser.token;
      this.loginUserDetails.name = loginUser.userDetail.name;
      this.loginUserDetails.isAdmin = true;
      this.loginUserDetails.profileImage = loginUser.userDetail.profileImage;
      this.loginUserDetails.partnertypeId = "-1";
      this.loginUserDetails.partnertype = "Administrator";

    }
  }
 



}


